import type { IconNode } from '../types';

/**
 * @name candle-tealight
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTJWNyIgLz4KICA8ZWxsaXBzZSBjeD0iMTIiIGN5PSIxMyIgcng9IjEwIiByeT0iMyIgLz4KICA8cGF0aCBkPSJNMiAxM3Y2YzAgMS43IDQuNSAzIDEwIDNzMTAtMS4zIDEwLTN2LTYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/candle-tealight
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const candleTealight: IconNode = [
  ['path', { d: 'M12 12V7', key: '1tf3mz' }],
  ['ellipse', { cx: '12', cy: '13', rx: '10', ry: '3', key: '1u2m43' }],
  ['path', { d: 'M2 13v6c0 1.7 4.5 3 10 3s10-1.3 10-3v-6', key: 'ac4evn' }],
];

export default candleTealight;
